import { Action } from "redux"
import { ThunkDispatch } from "redux-thunk"
import { ThunkResult, ApplicationState } from "../../../core/types"
import { WhatsNewActionTypes } from "./whats-new-types"
import { NewsFeedResponse } from "../../model/whats-new-model"

// The feed URL is sourced from the dev store (state.dev.rssFeedUrl). The /dev page exposes
// it as an editable field and it persists across reloads (redux-persist). That store value
// is seeded from REACT_APP_NEWS_FEED_URL (see dev-reducer.ts), so the env var still sets the
// default while the /dev field takes precedence. Read at fetch time — changing the field
// takes effect on the next page load (the feed is fetched once on nav mount).
// TODO: once SL nginx proxies this, switch to a relative path (/smrtlink-news/rss/feeds).

function ok<T>(data: T) {
    return { ok: true as const, data }
}
function fail() {
    return { ok: false as const, data: null }
}

async function fetchNewsFeed(url: string) {
    try {
        const res = await fetch(url)
        if (!res.ok) return fail()
        const data = (await res.json()) as NewsFeedResponse
        // Guard against a 200 response whose body isn't the feed envelope — otherwise a
        // non-array `items` propagates to the store and crashes the nav bar on `.length`.
        if (!data || !Array.isArray(data.items)) return fail()
        return ok(data)
    } catch {
        return fail()
    }
}

export const fetchWhatsNewFeed = (): ThunkResult<Promise<void>> => async (
    dispatch: ThunkDispatch<ApplicationState, undefined, Action>,
    getState: () => ApplicationState
) => {
    dispatch({ type: WhatsNewActionTypes.API_ATTEMPT })
    const response = await fetchNewsFeed(getState().dev.rssFeedUrl)
    if (response.ok) {
        dispatch({ type: WhatsNewActionTypes.SET_FEED, payload: response.data.items })
    } else {
        dispatch({ type: WhatsNewActionTypes.API_FAILURE, payload: new Error("Failed to fetch news feed") })
    }
}

export const setWhatsNewOpen = (isOpen: boolean) => ({
    type: WhatsNewActionTypes.SET_OPEN,
    payload: isOpen,
})
